export default "__VITE_ASSET__pdmhmXBJ__"